import { z } from 'zod'

export const TransactionStatusSchema = z.number().transform((value) => {
  switch (value) {
    case 1:
      return 'Completed'
    case 2:
      return 'Declined'
    case 3:
      return 'In review'
    case 4:
      return 'Refunded by Provider'
    default:
      return 'Unknown'
  }
})

export type TransactionStatus = z.infer<typeof TransactionStatusSchema>
